import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChainLink1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChainLink1"><Path fillRule="evenodd" clipRule="evenodd" d="M14.5 1.43945L22.5606 9.50011L17.75 14.3108L16.6893 13.2501L20.4393 9.50011L14.5 3.56077L10.75 7.31077L9.68933 6.25011L14.5 1.43945ZM16.0607 9.00011L8.99999 16.0608L7.93933 15.0001L15 7.93945L16.0607 9.00011ZM7.31065 10.7501L3.56065 14.5001L9.49999 20.4395L13.25 16.6895L14.3107 17.7501L9.49999 22.5608L1.43933 14.5001L6.24999 9.68945L7.31065 10.7501Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChainLink1;
